import {
  CostConstraintAdjustmentSchema,
  type CostConstraintAdjustment,
  type LineBuyTerms,
  type PpvReceiveAt,
} from '@erp/shared-types';
import { costConstraintCost } from '@erp/shared-utils';
import type { AssignmentLine } from '@erp/rpc';

export function initialReceiveCostInput(terms: LineBuyTerms) {
  const kind: CostConstraintAdjustment['kind'] =
    terms.costConstraintUnitCost == null ? 'savings_percent' : 'amount';
  return {
    basis: terms.ppvReceiveAt ?? 'cost_constraint',
    kind,
    value: terms.costConstraintUnitCost ?? '50',
  };
}

function previewCost(
  line: AssignmentLine,
  adjustment: CostConstraintAdjustment,
) {
  return costConstraintCost(
    line.buyerUnitCost,
    line.topOption?.unitCost ?? null,
    adjustment,
  );
}

export function receiveCostInputState(
  line: AssignmentLine,
  targets: readonly AssignmentLine[],
  basis: PpvReceiveAt,
  input: CostConstraintAdjustment,
) {
  const parsed = CostConstraintAdjustmentSchema.safeParse({
    ...input,
    value: input.value.trim(),
  });
  const adjustment = parsed.success ? parsed.data : undefined;
  const valid =
    targets.length > 0 &&
    (basis !== 'cost_constraint' ||
      (adjustment !== undefined &&
        targets.every((target) => previewCost(target, adjustment) !== null)));
  return {
    adjustment,
    valid,
    preview: adjustment ? previewCost(line, adjustment) : null,
  };
}
